<template>
  <div v-if="modalCheck" id="alert_modal" class="modal-wrap">
    <div class="modal-container">
      <div class="modal_header">
        <div class="header_close"></div>
        <div class="header_txt"></div>
        <div class="header_close">
          <!-- <a rel="modal:close" class="close_modal">
            <img src="../assets/images/icon/modal_close.png" alt="" />
          </a> -->
        </div>
      </div>
      <div class="modal_body">
        <div class="modal_contents" v-html="resultValue"></div>
      </div>
      <div class="modal_footer">
        <!--
          checkCost는 ContentsInner에서 받아오는 errCost임, 구매 할 옵션 미 선택시 넘어옴
          만약 OrderList.vue에서 errCost 안 넘겨주면 ContensInner에서 넘겨준다고 생각해서 이상해짐
          checkDone은 OrderList.vue에서 받아오는 doneCheck임, doneCheck로 환불 alert을 띄울지 말지 결정.
          doneCheck가 참이면 취소, 취소요청완료 건이라서 이게 뜨고 거짓이면 미완료 건이라서 취소요청창 뜸.

        -->
        <div v-if="checkCost && !checkDone" class="btn_area">
          <button
            href="#close-modal"
            rel="modal:close"
            class="btn_basic"
            @click="closeModal()"
          >
            확인
          </button>
        </div>
        <div v-else-if="checkCost && checkDone" class="btn_area">
          <button
            href="#close-modal"
            rel="modal:close"
            class="btn_basic"
            @click="moveInquiry()"
          >
            문의하러 가기
          </button>
          <button
            class="confirm_modal_cancel btn_basic confirm_close"
            @click="closeModal()"
          >
            확인
          </button>
        </div>
        <div v-else class="btn_area">
          <button
            v-if="errTriggerChk === 'orderTrigger'"
            href="#close-modal"
            rel="modal:close"
            class="btn_basic"
            @click="moveLoginPage()"
          >
            확인
          </button>

          <button
            v-else-if="errTriggerChk === 'uninstall'"
            href="#close-modal"
            rel="modal:close"
            class="btn_basic"
            @click="moveDownload()"
          >
            확인
          </button>

          <!-- 자체 배송을 눌렀을때 뜨는 alert -->
          <button
            v-else-if="errTriggerChk === 'nonInvoiceCourier'"
            href="#close-modal"
            rel="modal:close"
            class="btn_basic"
            @click="closeModal()"
          >
            확인
          </button>

          <!-- 로그인 토큰 만료시 -->
          <button
            v-else-if="tokenExpire === true && checkCost === false"
            href="#close-modal"
            rel="modal:close"
            class="btn_basic"
            @click="doLogout()"
          >
            로그인 만료됨~ 확인
          </button>

          <!-- 콘텐츠가 존재하지 않을때 발생하는 alert -->
          <button
            v-else
            href="#close-modal"
            rel="modal:close"
            class="btn_basic"
            @click="movetoContents()"
          >
            확인
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { deleteToken } from '../api/loginout'

export default {
  props: {
    // eslint-disable-next-line vue/require-default-prop
    alertMsg: String,
    isOpen: Boolean,
    isCost: Boolean,
    isDone: Boolean,
    // eslint-disable-next-line vue/require-default-prop
    trigger: String,
    tokenExpire: Boolean,
  },
  emits: ['update:isOpen'],

  setup(props, { emit }) {
    const router = useRouter()

    const resultValue = ref('')
    const modalCheck = ref('')
    const checkCost = ref('')
    const checkDone = ref('')
    const errTriggerChk = ref('')
    const loginDone = ref('')

    watch(
      () => props.isOpen,
      () => {
        modalCheck.value = props.isOpen
        resultValue.value = props.alertMsg
        checkCost.value = props.isCost
        checkDone.value = props.isDone
        errTriggerChk.value = props.trigger
        loginDone.value = props.tokenExpire
      }
    )

    const closeModal = () => {
      emit('update:isOpen', false)
    }

    const movetoContents = () => {
      emit('update:isOpen', false)
      router.push({ path: '/contents' })
    }

    const moveLoginPage = () => {
      emit('update:isOpen', false)
      router.push({ name: 'LoginViews' })
    }
    const moveDownload = () => {
      emit('update:isOpen', false)
      router.push({ name: 'DownloadViews' })
    }
    const moveInquiry = () => {
      emit('update:isOpen', false)
      router.push({ name: 'InquiryViews' })
    }
    const doLogout = async () => {
      await deleteToken()
      emit('update:isOpen', false)
    }

    return {
      resultValue,
      modalCheck,
      checkCost,
      checkDone,
      errTriggerChk,
      loginDone,
      closeModal,
      movetoContents,
      moveLoginPage,
      moveDownload,
      moveInquiry,
      doLogout,
    }
  },
}
</script>
<style>
/* dimmed */
.modal-wrap {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 5;
}

.modal-container {
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 550px;
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;
  padding: 1.5rem 1.5rem 1.5rem 1.5rem !important;
  border-radius: 1.25rem !important;
  z-index: 5;
}

.modal-container .modal_header {
  margin-bottom: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 5;
}

.modal-container .modal_header .close_modal {
  display: block !important;
  width: 1rem !important;
  height: 1rem !important;
  z-index: 5;
}

.modal-container .modal_header .close_modal img {
  width: 100%;
  z-index: 5;
}

.modal-container .modal_body {
  margin-bottom: 1.25rem;
  z-index: 5;
}

.modal-container .modal_body .modal_contents {
  text-align: center;
  font-weight: 300;
  font-size: 1rem;
  line-height: 1.4375rem;
  color: #2d2d2d;
  z-index: 5;
}

.modal-container .modal_footer .btn_area {
  display: flex;
  gap: 0.5rem;
  z-index: 5;
}

.modal-container .modal_footer .btn_area button,
.modal-container .modal_footer .btn_area div {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 100%;
  height: 3.25rem;
  font-size: 1rem;
  font-weight: bold;
  z-index: 5;
}

.modal-container .modal_footer .btn_area .confirm_close {
  color: #2d2d2d;
  background-color: #dfdfdf;
  border: 1px solid #dfdfdf;
  z-index: 5;
}
</style>
